// extracted by mini-css-extract-plugin
export default {"completeButton":"EventStatus_completeButton__Aaxs8","quarantineMessage":"EventStatus_quarantineMessage__Wvf3n"};